import React from 'react'
import ReactDOM from 'react-dom/client'

// Blueprint.js base styles. @blueprintjs/icons stylesheet is needed for the
// icon font to render. Dockview styles come later in Phase 1 when we build
// the actual workspace.
import '@blueprintjs/core/lib/css/blueprint.css'
import '@blueprintjs/icons/lib/css/blueprint-icons.css'

import { App } from './App'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
